import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface Slide6Props {
  isDark?: boolean;
}
export function Slide6({
  isDark = false
}: Slide6Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-910">
      <div className="min-h-full flex flex-col justify-center items-center max-w-4xl mx-auto px-4 sm:px-8 py-16 sm:py-20 text-center" data-id="element-911">
        <motion.h1 variants={itemVariants} className={`text-3xl sm:text-5xl font-serif font-medium mb-4 sm:mb-6 leading-tight px-4 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-912">
          Ready to Transform Your
          <br data-id="element-913" />
          <span className={`italic ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-914">
            Leadership Investment?
          </span>
        </motion.h1>

        <motion.p variants={itemVariants} className={`text-base sm:text-xl mb-8 sm:mb-12 max-w-2xl leading-relaxed px-4 ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-915">
          Join forward-thinking organizations investing in sustainable
          leadership wellness
        </motion.p>

        <motion.a variants={itemVariants} href="https://calendly.com/abrahamadvocate/short-heliona-demo" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 sm:gap-3 px-8 sm:px-10 py-4 sm:py-5 bg-heliona-mint hover:bg-heliona-mint-dark text-heliona-navy font-semibold text-base sm:text-lg rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105" data-id="element-916">
          Reserve Your Seat
          <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" data-id="element-917" />
        </motion.a>

        <motion.p variants={itemVariants} className={`text-xs sm:text-sm mt-6 sm:mt-8 ${isDark ? 'text-white/60' : 'text-heliona-text-gray/70'}`} data-id="element-918">
          Limited pilot program availability
        </motion.p>
      </div>
    </motion.div>;
}